/** Makeup Studio v2 preset ids for Gemma + palette resolve (blush / lip / shadow auto slots). */

export const V3_PRESET_STUDIO_MAP = {
  'morning-sheer': 'natural',
  'morning-peach': 'everyday',
  'day-office': 'office',
  'day-soft-nude': 'everyday',
  'evening-rose-gold': 'soft_glam',
  'evening-smoky': 'casual',
  'night-party': 'party_glow',
  'night-red-carpet': 'reception',
  'ceremony-indian': 'south_indian_bridal',
  'ceremony-bridal-soft': 'engagement',
  'bridal-look': 'engagement',
};

export function studioPresetForV3Preset(presetId) {
  if (!presetId) return 'everyday';
  return V3_PRESET_STUDIO_MAP[presetId] || 'everyday';
}
